import { MessageCircle } from "lucide-react";
import { PRODUCTS, waLink } from "../../lib/site";

export const Collection = () => {
  return (
    <section
      id="collection"
      className="relative py-20 md:py-32 bg-sand/60 border-y border-line"
    >
      <div className="container-narrow">
        <div className="flex flex-col items-start md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
          <div className="max-w-2xl">
            <span className="overline">Featured · December '26</span>
            <h2 className="mt-3 font-serif text-4xl md:text-6xl text-ink">
              The handpicked <span className="italic text-garnet">edit</span>.
            </h2>
          </div>
          <p className="md:max-w-sm text-muteink leading-relaxed">
            A rotating selection of seven sarees we're loving this month. Tap any
            piece to inquire — we'll send detailed photos, weave notes & price.
          </p>
        </div>

        {/* Editorial bento */}
        <div className="grid grid-cols-12 grid-flow-dense gap-4 md:gap-6">
          {PRODUCTS.map((p, i) => {
            const layout = [
              "col-span-12 md:col-span-6 md:row-span-2 h-[420px] md:h-[820px]",
              "col-span-6 md:col-span-3 h-[300px] md:h-[400px]",
              "col-span-6 md:col-span-3 h-[300px] md:h-[400px]",
              "col-span-12 md:col-span-3 h-[320px] md:h-[400px]",
              "col-span-6 md:col-span-3 h-[300px] md:h-[400px]",
              "col-span-6 md:col-span-3 h-[300px] md:h-[400px]",
              "col-span-12 md:col-span-3 h-[320px] md:h-[400px]",
            ];
            return (
              <article
                key={p.id}
                data-testid={`product-card-${p.id}`}
                className={`group relative overflow-hidden bg-cream ${layout[i]}`}
              >
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-transparent opacity-90" />

                <div className="absolute top-4 left-4">
                  <span className="text-[10px] tracking-[0.25em] uppercase bg-cream/95 text-garnet px-3 py-1.5">
                    {p.cat}
                  </span>
                </div>

                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-cream leading-tight">
                      {p.title}
                    </h3>
                    <p className="text-cream/75 text-xs tracking-[0.2em] uppercase mt-1">
                      {p.price}
                    </p>
                  </div>

                  <a
                    href={waLink(`Hi! I'd like more details about "${p.title}" (${p.cat}).`)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="product-card-whatsapp-cta"
                    className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 inline-flex items-center gap-2 bg-gold text-ink px-4 py-2.5 text-[11px] tracking-[0.22em] uppercase hover:bg-cream"
                  >
                    <MessageCircle size={14} />
                    Inquire
                  </a>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-14 flex justify-center">
          <a
            href={waLink("Hi! I'd love to see your full saree collection.")}
            target="_blank"
            rel="noreferrer"
            data-testid="collection-view-all-cta"
            className="btn-outline-dark"
          >
            View Full Catalogue
          </a>
        </div>
      </div>
    </section>
  );
};

export default Collection;
